


// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import '../styles/Attendance.css';

// const WorkFromHome = () => {
//     const navigate = useNavigate();

//     useEffect(() => {
//         const prevTheme = document.documentElement.getAttribute('data-theme');
//         document.documentElement.setAttribute('data-theme', 'light');

//         const prevBodyBg = document.body.style.backgroundColor;
//         const prevBodyColor = document.body.style.color;
//         document.body.style.backgroundColor = '#f8fafc';
//         document.body.style.color = '#1e293b';

//         return () => {
//             if (prevTheme) {
//                 document.documentElement.setAttribute('data-theme', prevTheme);
//             } else {
//                 document.documentElement.removeAttribute('data-theme');
//             }
//             document.body.style.backgroundColor = prevBodyBg;
//             document.body.style.color = prevBodyColor;
//         };
//     }, []);

//     const PUBLIC_HOLIDAYS = [
//         '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
//         '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
//     ];

//     const [wfhForm, setWfhForm] = useState({
//         start: '',
//         end: '',
//         reason: ''
//     });

//     const [isHalfDay, setIsHalfDay] = useState(null);

//     const [unit, setUnit] = useState(0);
//     const [wfhHistory, setWfhHistory] = useState([]);
//     const [editingId, setEditingId] = useState(null);
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [wfhUsed, setWfhUsed] = useState(0);

//     const [modal, setModal] = useState({
//         show: false,
//         title: '',
//         message: '',
//         type: '',
//         action: null
//     });

//     const startDateRef = useRef(null);
//     const endDateRef = useRef(null);

//     /* ---------- WORKDAY CHECK ---------- */

//     const isWorkDay = (date) => {

//         const day = date.getDay();
//         const dateStr = date.toISOString().split('T')[0];

//         const isWeekend = day === 0 || day === 6;
//         const isHoliday = PUBLIC_HOLIDAYS.includes(dateStr);

//         return !isWeekend && !isHoliday;

//     };

//     /* ---------- CALCULATE WORKING DAYS ---------- */

//     const calculateUnits = (start, end) => {

//         if (!start || !end) return 0;

//         let s = new Date(start);
//         let e = new Date(end);

//         let count = 0;
//         let temp = new Date(s);

//         while (temp <= e) {

//             if (isWorkDay(temp)) count++;

//             temp.setDate(temp.getDate() + 1);

//         }

//         return count;

//     };

//     /* ---------- AUTO UNIT ---------- */

//     useEffect(() => {

//         if (!wfhForm.start || !wfhForm.end) return;

//         // ✅ SAME DAY → ASK HALF DAY
//         if (wfhForm.start === wfhForm.end && isHalfDay === null) {

//             setModal({
//                 show: true,
//                 title: "HALF DAY REQUEST",
//                 message: `Is this a Half-Day WFH for ${wfhForm.start}?`,
//                 type: "query",
//                 action: (choice) => {
//                     setIsHalfDay(choice);
//                     setModal({ show: false });
//                 }
//             });

//             return;
//         }

//         // ✅ CALCULATE UNIT
//         let total = 0;

//         if (wfhForm.start === wfhForm.end) {
//             total = isHalfDay ? 0.5 : 1;
//         } else {
//             total = calculateUnits(wfhForm.start, wfhForm.end);
//         }

//         setUnit(total);

//     }, [wfhForm.start, wfhForm.end, isHalfDay]);

//     useEffect(() => {
//         setIsHalfDay(null);
//     }, [wfhForm.start, wfhForm.end]);

//     /* ---------- FETCH HISTORY ---------- */

//     const fetchWFHHistory = useCallback(async () => {

//         try {

//             const res = await fetch(
//                 "/gt-api/get_wfh.php",
//                 { credentials: "include" }
//             );

//             const data = await res.json();

//             if (data.success) {

//                 const logs = data.requests || [];

//                 setWfhHistory(logs);

//                 let used = 0;

//                 logs.forEach(r => {
//                     if (r.status !== "Rejected") {
//                         used += parseFloat(r.total_days || 0);
//                     }
//                 });

//                 setWfhUsed(used);

//             }

//         } catch (err) {

//             console.error("WFH fetch error", err);

//         }

//     }, []);

//     useEffect(() => {
//         fetchWFHHistory();
//     }, [fetchWFHHistory]);

//     /* ---------- SUBMIT ---------- */

//     const submitWFH = async (e) => {

//         e.preventDefault();

//         if (unit <= 0) {

//             setModal({
//                 show: true,
//                 title: "INVALID REQUEST",
//                 message: "Selected dates contain no working days.",
//                 type: "error"
//             });

//             return;

//         }

//         setIsSubmitting(true);

//         const formData = new FormData();

//         formData.append("id", editingId);
//         formData.append("start", wfhForm.start);
//         formData.append("end", wfhForm.end);
//         formData.append("total_days", unit);
//         formData.append("reason", wfhForm.reason);

//         try {

//             const res = await fetch(
//                 "/gt-api/apply_wfh.php",
//                 {
//                     method: "POST",
//                     credentials: "include",
//                     body: formData
//                 });

//             const result = await res.json();

//             if (result.success) {

//                 setModal({
//                     show: true,
//                     title: "SUCCESS",
//                     message: "WFH request submitted successfully",
//                     type: "success"
//                 });

//                 setWfhForm({ start: '', end: '', reason: '' });
//                 setEditingId(null);
//                 setUnit(0);

//                 fetchWFHHistory();

//             }

//         } catch (err) {

//             setModal({
//                 show: true,
//                 title: "SERVER ERROR",
//                 message: "Unable to submit request",
//                 type: "error"
//             });

//         }

//         finally {

//             setIsSubmitting(false);

//         }

//     };

//     /* ---------- EDIT ---------- */

//     const handleModify = (log) => {

//         setEditingId(log.id);

//         setWfhForm({
//             start: log.start,
//             end: log.end,
//             reason: log.reason
//         });

//         window.scrollTo({ top: 0, behavior: 'smooth' });

//     };

//     /* ---------- DELETE ---------- */

//     const handleDelete = (id) => {

//         setModal({

//             show: true,
//             title: "CONFIRM DELETE",
//             message: "Remove this request?",
//             type: "query",

//             action: async (choice) => {

//                 if (!choice) {
//                     setModal({ show: false });
//                     return;
//                 }

//                 try {

//                     await fetch(
//                         `/gt-api/delete_wfh.php?id=${id}`,
//                         { credentials: "include" }
//                     );

//                     fetchWFHHistory();

//                 } catch (err) {

//                     console.error(err);

//                 }

//                 setModal({ show: false });

//             }

//         });

//     };

//     return (



//         <div className="attendance-module light-theme">

//             <button
//                 className="wfh-top-btn"
//                 onClick={() => navigate(-1)}
//             >
//                 ⬅ Back to Attendance
//             </button>

//             <div className="leave-stats-grid">

//                 <div className="stat-highlight glass" style={{ "--accent": "#3b82f6" }}>

//                     <span className="stat-label">WFH USED</span>

//                     <h1 className="big-stat-text">{wfhUsed}</h1>

//                     <div className="stat-footer">
//                         Total Work From Home Days
//                     </div>

//                 </div>

//             </div>

//             {modal.show && (

//                 <div className="cyber-modal-overlay">

//                     <div className={`cyber-modal-card ${modal.type}`}>

//                         <h3>{modal.title}</h3>
//                         <p className="modal-text">{modal.message}</p>

//                         <div className="modal-actions">

//                             {modal.type === 'query' ? (

//                                 <>
//                                     <button className="btn-yes" onClick={() => modal.action(true)}>YES</button>
//                                     <button className="btn-no" onClick={() => modal.action(false)}>NO</button>
//                                 </>

//                             ) : (

//                                 <button className="btn-close" onClick={() => setModal({ ...modal, show: false })}>
//                                     CLOSE </button>

//                             )}

//                         </div>

//                     </div>

//                 </div>

//             )}

//             <div className="attendance-layout">

//                 <div className="panel glass">

//                     <div className="panel-header">

//                         <h3 className="panel-title">
//                             {editingId ? "Update WFH Request" : "New WFH Request"}
//                         </h3>

//                         <span className="deduction-badge">{unit} Units</span>

//                     </div>

//                     <form onSubmit={submitWFH}>

//                         <div className="input-row">

//                             <div className="input-group date-input">
//                                 <label>START DATE</label>

//                                 <div className="date-wrapper">

//                                     <input
//                                         ref={startDateRef}
//                                         type="date"
//                                         className="cyber-input"
//                                         required
//                                         value={wfhForm.start}
//                                         onChange={(e) =>
//                                             setWfhForm({
//                                                 ...wfhForm,
//                                                 start: e.target.value
//                                             })
//                                         }
//                                     />

//                                     <button
//                                         type="button"
//                                         className="calendar-icon"
//                                         onClick={() => startDateRef.current?.showPicker()}
//                                     >
//                                         📅
//                                     </button>

//                                 </div>
//                             </div>
//                             <div className="input-group date-input">
//                                 <label>END DATE</label>

//                                 <div className="date-wrapper">

//                                     <input
//                                         ref={endDateRef}
//                                         type="date"
//                                         className="cyber-input"
//                                         required
//                                         min={wfhForm.start}
//                                         value={wfhForm.end}
//                                         onChange={(e) =>
//                                             setWfhForm({
//                                                 ...wfhForm,
//                                                 end: e.target.value
//                                             })
//                                         }
//                                     />

//                                     <button
//                                         type="button"
//                                         className="calendar-icon"
//                                         onClick={() => endDateRef.current?.showPicker()}
//                                     >
//                                         📅
//                                     </button>

//                                 </div>

//                             </div>

//                         </div>

//                         <div className="input-group">
//                             <label>REASON</label>
//                             <textarea
//                                 className="cyber-input"
//                                 required
//                                 value={wfhForm.reason}
//                                 onChange={(e) => setWfhForm({ ...wfhForm, reason: e.target.value })}
//                             />
//                         </div>

//                         <button type="submit" className="submit-btn" disabled={isSubmitting}>
//                             {isSubmitting ? "PROCESSING..." : editingId ? "UPDATE REQUEST" : "APPLY WFH"}
//                         </button>

//                     </form>

//                 </div>

//                 <div className="panel glass">

//                     <h3 className="panel-title">Application Log</h3>

//                     <div className="table-scroll">

//                         <table className="history-table">

//                             <thead>
//                                 <tr>
//                                     <th>SR.NO</th>
//                                     <th>FROM</th>
//                                     <th>TO</th>
//                                     <th>DAYS</th>
//                                     <th>STATUS</th>
//                                     <th>ACTION</th>
//                                 </tr>
//                             </thead>

//                             <tbody>

//                                 {wfhHistory.map((log, i) => {

//                                     const isApproved = log.status === "Approved";
//                                     const isRejected = log.status === "Rejected";
//                                     const isPending = log.status === "Pending";

//                                     return (

//                                         <tr key={log.id || i}>

//                                             <td>{i + 1}</td>

//                                             <td>
//                                                 {log.start
//                                                     ? new Date(log.start).toLocaleDateString('en-GB')
//                                                     : "-"}
//                                             </td>

//                                             <td>
//                                                 {log.end
//                                                     ? new Date(log.end).toLocaleDateString('en-GB')
//                                                     : "-"}
//                                             </td>

//                                             <td>{log.total_days}</td>

//                                             <td>
//                                                 <span className={`status-pill ${isApproved ? 'approved' : (isRejected ? 'rejected' : 'pending')}`}>
//                                                     {log.status}
//                                                 </span>
//                                             </td>

//                                             {/* ✅ ADD THIS COLUMN */}
//                                             <td>
//                                                 {isPending && (
//                                                     <div className="action-btns">
//                                                         <button
//                                                             className="edit-btn"
//                                                             onClick={() => handleModify(log)}
//                                                         >
//                                                             ✎
//                                                         </button>

//                                                         <button
//                                                             className="del-btn"
//                                                             onClick={() => handleDelete(log.id)}
//                                                         >
//                                                             ✕
//                                                         </button>
//                                                     </div>
//                                                 )}
//                                             </td>

//                                         </tr>

//                                     );

//                                 })}

//                             </tbody>

//                         </table>

//                     </div>

//                 </div>

//             </div>

//         </div>

//     );

// };

// export default WorkFromHome;
































import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Attendance.css';

const TOTAL_ANNUAL_WFH_ALLOWANCE = 12;
const POLICY_EFFECTIVE_DATE = '2026-09-22';

const getCurrentFinancialYear = (refDate = new Date()) => {
    const year = refDate.getFullYear();
    const month = refDate.getMonth(); // 0 = Jan, 3 = Apr
    const fyStartYear = month >= 3 ? year : year - 1;
    const fyEndYear = fyStartYear + 1;

    return {
        fyStartYear,
        fyEndYear,
        startDateStr: `${fyStartYear}-04-01`,
        endDateStr: `${fyEndYear}-03-31`,
        label: `FY ${fyStartYear}-${fyEndYear.toString().slice(-2)}`
    };
};

const WorkFromHome = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const prevTheme = document.documentElement.getAttribute('data-theme');
        document.documentElement.setAttribute('data-theme', 'light');

        const prevBodyBg = document.body.style.backgroundColor;
        const prevBodyColor = document.body.style.color;
        document.body.style.backgroundColor = '#f8fafc';
        document.body.style.color = '#1e293b';

        return () => {
            if (prevTheme) {
                document.documentElement.setAttribute('data-theme', prevTheme);
            } else {
                document.documentElement.removeAttribute('data-theme');
            }
            document.body.style.backgroundColor = prevBodyBg;
            document.body.style.color = prevBodyColor;
        };
    }, []);

    const PUBLIC_HOLIDAYS = [
        '2026-01-01', '2026-01-26', '2026-03-19', '2026-05-01', '2026-05-27',
        '2026-09-14', '2026-10-02', '2026-10-20', '2026-11-09', '2026-12-25'
    ];

    const [wfhForm, setWfhForm] = useState({
        start: '',
        end: '',
        reason: ''
    });

    const [isHalfDay, setIsHalfDay] = useState(null);

    const [unit, setUnit] = useState(0);
    const [wfhHistory, setWfhHistory] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [wfhUsed, setWfhUsed] = useState(0);
    const [wfhRemaining, setWfhRemaining] = useState(TOTAL_ANNUAL_WFH_ALLOWANCE);

    const [modal, setModal] = useState({
        show: false,
        title: '',
        message: '',
        type: '',
        action: null
    });

    const startDateRef = useRef(null);
    const endDateRef = useRef(null);

    /* ---------- LOCAL DATE HELPER ---------- */

    const getLocalDateStr = (d) => {
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    /* ---------- WORKDAY CHECK ---------- */

    const isWorkDay = (date) => {

        const day = date.getDay();
        const dateStr = getLocalDateStr(date);

        const isWeekend = day === 0 || day === 6;
        const isHoliday = PUBLIC_HOLIDAYS.includes(dateStr);

        return !isWeekend && !isHoliday;

    };

    /* ---------- CALCULATE WORKING DAYS ---------- */

    const calculateUnits = (start, end) => {

        if (!start || !end) return 0;

        const [sYear, sMonth, sDay] = start.split('-').map(Number);
        const [eYear, eMonth, eDay] = end.split('-').map(Number);

        let temp = new Date(sYear, sMonth - 1, sDay);
        let endDate = new Date(eYear, eMonth - 1, eDay);

        let count = 0;

        while (temp <= endDate) {

            if (isWorkDay(temp)) count++;

            temp.setDate(temp.getDate() + 1);

        }

        return count;

    };

    /* ---------- AUTO UNIT ---------- */

    useEffect(() => {

        if (!wfhForm.start || !wfhForm.end) return;

        // ✅ SAME DAY → ASK HALF DAY
        if (wfhForm.start === wfhForm.end && isHalfDay === null) {

            setModal({
                show: true,
                title: "HALF DAY REQUEST",
                message: `Is this a Half-Day WFH for ${wfhForm.start}?`,
                type: "query",
                action: (choice) => {
                    setIsHalfDay(choice);
                    setModal({ show: false });
                }
            });

            return;
        }

        // ✅ CALCULATE UNIT
        let total = 0;

        if (wfhForm.start === wfhForm.end) {
            total = isHalfDay ? 0.5 : 1;
        } else {
            total = calculateUnits(wfhForm.start, wfhForm.end);
        }

        setUnit(total);

    }, [wfhForm.start, wfhForm.end, isHalfDay]);

    useEffect(() => {
        setIsHalfDay(null);
    }, [wfhForm.start, wfhForm.end]);

    /* ---------- FETCH HISTORY ---------- */

    const fetchWFHHistory = useCallback(async () => {

        try {

            const res = await fetch(
                "/gt-api/get_wfh.php",
                { credentials: "include" }
            );

            const data = await res.json();

            if (data.success) {

                const logs = data.requests || [];

                setWfhHistory(logs);

                const currentFY = getCurrentFinancialYear();
                let used = 0;

                logs.forEach(r => {
                    // Count only if status is not Rejected AND start date is within current Financial Year AND >= POLICY_EFFECTIVE_DATE
                    if (r.status !== "Rejected" && r.start) {
                        const reqStart = r.start;
                        if (
                            reqStart >= currentFY.startDateStr &&
                            reqStart <= currentFY.endDateStr &&
                            reqStart >= POLICY_EFFECTIVE_DATE
                        ) {
                            used += parseFloat(r.total_days || 0);
                        }
                    }
                });

                setWfhUsed(used);
                setWfhRemaining(Math.max(0, TOTAL_ANNUAL_WFH_ALLOWANCE - used));

            }

        } catch (err) {

            console.error("WFH fetch error", err);

        }

    }, []);

    useEffect(() => {
        fetchWFHHistory();
    }, [fetchWFHHistory]);

    /* ---------- SUBMIT ---------- */

    const submitWFH = async (e) => {

        e.preventDefault();

        if (unit <= 0) {

            setModal({
                show: true,
                title: "INVALID REQUEST",
                message: "Selected dates contain no working days.",
                type: "error"
            });

            return;

        }

        // Calculate effective remaining allowance by adding back the days of the request being edited
        let existingEditingDays = 0;
        if (editingId) {
            const editingLog = wfhHistory.find(r => String(r.id) === String(editingId));
            if (editingLog && editingLog.status !== "Rejected") {
                existingEditingDays = parseFloat(editingLog.total_days || 0);
            }
        }

        const effectiveRemaining = wfhRemaining + existingEditingDays;

        if (unit > effectiveRemaining) {

            const currentFY = getCurrentFinancialYear();

            setModal({
                show: true,
                title: "WFH ALLOWANCE EXCEEDED",
                message: `You have only ${effectiveRemaining} WFH day(s) remaining for ${currentFY.label}. You cannot apply for ${unit} day(s).`,
                type: "error"
            });

            return;

        }

        setIsSubmitting(true);

        const formData = new FormData();

        formData.append("id", editingId);
        formData.append("start", wfhForm.start);
        formData.append("end", wfhForm.end);
        formData.append("total_days", unit);
        formData.append("reason", wfhForm.reason);

        try {

            const res = await fetch(
                "/gt-api/apply_wfh.php",
                {
                    method: "POST",
                    credentials: "include",
                    body: formData
                });

            const result = await res.json();

            if (result.success) {

                setModal({
                    show: true,
                    title: "SUCCESS",
                    message: "WFH request submitted successfully",
                    type: "success"
                });

                setWfhForm({ start: '', end: '', reason: '' });
                setEditingId(null);
                setUnit(0);

                fetchWFHHistory();

            }

        } catch (err) {

            setModal({
                show: true,
                title: "SERVER ERROR",
                message: "Unable to submit request",
                type: "error"
            });

        }

        finally {

            setIsSubmitting(false);

        }

    };

    /* ---------- EDIT ---------- */

    const handleModify = (log) => {

        setEditingId(log.id);

        setWfhForm({
            start: log.start,
            end: log.end,
            reason: log.reason
        });

        window.scrollTo({ top: 0, behavior: 'smooth' });

    };

    /* ---------- DELETE ---------- */

    const handleDelete = (id) => {

        setModal({

            show: true,
            title: "CONFIRM DELETE",
            message: "Remove this request?",
            type: "query",

            action: async (choice) => {

                if (!choice) {
                    setModal({ show: false });
                    return;
                }

                try {

                    await fetch(
                        `/gt-api/delete_wfh.php?id=${id}`,
                        { credentials: "include" }
                    );

                    fetchWFHHistory();

                } catch (err) {

                    console.error(err);

                }

                setModal({ show: false });

            }

        });

    };

    return (

        <div className="attendance-module light-theme">

            <button
                className="wfh-top-btn"
                onClick={() => navigate(-1)}
            >
                ⬅ Back to Attendance
            </button>

            <div className="leave-stats-grid">

                <div className="stat-highlight glass" style={{ "--accent": "#3b82f6" }}>

                    <span className="stat-label">WFH REMAINING</span>

                    <h1 className="big-stat-text">{wfhRemaining}</h1>

                    <div className="stat-footer">
                        Used: {wfhUsed} / {TOTAL_ANNUAL_WFH_ALLOWANCE}
                    </div>

                </div>

            </div>

            {modal.show && (

                <div className="cyber-modal-overlay">

                    <div className={`cyber-modal-card ${modal.type}`}>

                        <h3>{modal.title}</h3>
                        <p className="modal-text">{modal.message}</p>

                        <div className="modal-actions">

                            {modal.type === 'query' ? (

                                <>
                                    <button className="btn-yes" onClick={() => modal.action(true)}>YES</button>
                                    <button className="btn-no" onClick={() => modal.action(false)}>NO</button>
                                </>

                            ) : (

                                <button className="btn-close" onClick={() => setModal({ ...modal, show: false })}>
                                    CLOSE </button>

                            )}

                        </div>

                    </div>

                </div>

            )}

            <div className="attendance-layout">

                <div className="panel glass">

                    <div className="panel-header">

                        <h3 className="panel-title">
                            {editingId ? "Update WFH Request" : "New WFH Request"}
                        </h3>

                        <span className="deduction-badge">{unit} Units</span>

                    </div>

                    <form onSubmit={submitWFH}>

                        <div className="input-row">

                            <div className="input-group date-input">
                                <label>START DATE</label>

                                <div className="date-wrapper">

                                    <input
                                        ref={startDateRef}
                                        type="date"
                                        className="cyber-input"
                                        required
                                        value={wfhForm.start}
                                        onChange={(e) =>
                                            setWfhForm({
                                                ...wfhForm,
                                                start: e.target.value
                                            })
                                        }
                                    />

                                    <button
                                        type="button"
                                        className="calendar-icon"
                                        onClick={() => startDateRef.current?.showPicker()}
                                    >
                                        📅
                                    </button>

                                </div>
                            </div>
                            <div className="input-group date-input">
                                <label>END DATE</label>

                                <div className="date-wrapper">

                                    <input
                                        ref={endDateRef}
                                        type="date"
                                        className="cyber-input"
                                        required
                                        min={wfhForm.start}
                                        value={wfhForm.end}
                                        onChange={(e) =>
                                            setWfhForm({
                                                ...wfhForm,
                                                end: e.target.value
                                            })
                                        }
                                    />

                                    <button
                                        type="button"
                                        className="calendar-icon"
                                        onClick={() => endDateRef.current?.showPicker()}
                                    >
                                        📅
                                    </button>

                                </div>

                            </div>

                        </div>

                        <div className="input-group">
                            <label>REASON</label>
                            <textarea
                                className="cyber-input"
                                required
                                value={wfhForm.reason}
                                onChange={(e) => setWfhForm({ ...wfhForm, reason: e.target.value })}
                            />
                        </div>

                        <button type="submit" className="submit-btn" disabled={isSubmitting}>
                            {isSubmitting ? "PROCESSING..." : editingId ? "UPDATE REQUEST" : "APPLY WFH"}
                        </button>

                    </form>

                </div>

                <div className="panel glass">

                    <h3 className="panel-title">Application Log</h3>

                    <div className="table-scroll">

                        <table className="history-table">

                            <thead>
                                <tr>
                                    <th>SR.NO</th>
                                    <th>FROM</th>
                                    <th>TO</th>
                                    <th>DAYS</th>
                                    <th>STATUS</th>
                                    <th>ACTION</th>
                                </tr>
                            </thead>

                            <tbody>

                                {wfhHistory.map((log, i) => {

                                    const isApproved = log.status === "Approved";
                                    const isRejected = log.status === "Rejected";
                                    const isPending = log.status === "Pending";

                                    return (

                                        <tr key={log.id || i}>

                                            <td>{i + 1}</td>

                                            <td>
                                                {log.start
                                                    ? new Date(log.start).toLocaleDateString('en-GB')
                                                    : "-"}
                                            </td>

                                            <td>
                                                {log.end
                                                    ? new Date(log.end).toLocaleDateString('en-GB')
                                                    : "-"}
                                            </td>

                                            <td>{log.total_days}</td>

                                            <td>
                                                <span className={`status-pill ${isApproved ? 'approved' : (isRejected ? 'rejected' : 'pending')}`}>
                                                    {log.status}
                                                </span>
                                            </td>

                                            {/* ✅ ADD THIS COLUMN */}
                                            <td>
                                                {isPending && (
                                                    <div className="action-btns">
                                                        <button
                                                            className="edit-btn"
                                                            onClick={() => handleModify(log)}
                                                        >
                                                            ✎
                                                        </button>

                                                        <button
                                                            className="del-btn"
                                                            onClick={() => handleDelete(log.id)}
                                                        >
                                                            ✕
                                                        </button>
                                                    </div>
                                                )}
                                            </td>

                                        </tr>

                                    );

                                })}

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

        </div>

    );

};

export default WorkFromHome;
